import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrentMobileResourceService } from './current-mobile-resource.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [CurrentMobileResourceService]
})
export class CurrentMobileResourceModule { }
